import { TextLink } from '@time-line/components/common';
import { useHcpLinkTracking } from 'hooks/useHcpLinkTracking';
import {
  getExternalLinkProps,
  getShowIconProps,
} from 'utils/getExternalLinkProps';
import { getTrackingId } from 'utils/getTrackingId';

interface NavLinkProps {
  href: string;
  isExternal?: boolean;
  label: string;
  name: string;
  platform: 'desktop' | 'mobile';
  showIcon?: boolean;
}

export function NavLink({
  href,
  isExternal,
  label,
  name,
  platform,
  showIcon,
}: NavLinkProps) {
  const trackHcpLinkClick = useHcpLinkTracking(name, { source: 'footer' });

  return (
    <TextLink
      {...getExternalLinkProps(isExternal, href)}
      {...getShowIconProps(showIcon)}
      href={href}
      textProps={{ size: 'overline' }}
      variant="underlineOnHover"
      id={getTrackingId(name, { parent: 'footer', platform })}
      onClick={trackHcpLinkClick}
      afterIconProps={
        showIcon ? { boxSize: '2xs', marginBottom: '2px' } : undefined
      }
    >
      {label}
    </TextLink>
  );
}
